/**
 * @generated SignedSource<<a066467835379671abbf48a6b5db283d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnlinkMutation$variables = {
  aaid: string;
};
export type UnlinkMutation$data = {
  readonly unified: {
    readonly account: {
      readonly unlinkAccount: {
        readonly errors: ReadonlyArray<{
          readonly code: string | null;
          readonly extensions: {
            readonly errorType: string | null;
            readonly statusCode: number | null;
          } | null;
          readonly message: string | null;
        }> | null;
        readonly message: string | null;
        readonly success: boolean;
      } | null;
    } | null;
  } | null;
};
export type UnlinkMutation = {
  response: UnlinkMutation$data;
  variables: UnlinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aaid"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UnifiedMutation",
    "kind": "LinkedField",
    "name": "unified",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedAccountMutation",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "aaid",
                "variableName": "aaid"
              }
            ],
            "concreteType": "UnifiedLinkingStatusPayload",
            "kind": "LinkedField",
            "name": "unlinkAccount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedMutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedMutationErrorExtension",
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "success",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnlinkMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnlinkMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2f12a625ba6043d1ea501760b6f917d9",
    "id": null,
    "metadata": {},
    "name": "UnlinkMutation",
    "operationKind": "mutation",
    "text": "mutation UnlinkMutation(\n  $aaid: String!\n) {\n  unified {\n    account {\n      unlinkAccount(aaid: $aaid) {\n        errors {\n          extensions {\n            errorType\n            statusCode\n          }\n          code\n          message\n        }\n        message\n        success\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e1591e859d8ee59f56cf997a9f7b428c";

export default node;
